$(function() {
  $(".quick_shop").hide();
  $(".product-cart input").click(function(){
  	var productId = $(this).attr("id");
    if(!$(this).is(":checked")){
      addToCart(productId);
    }
  });
  $(".product-cart label").click(function(){
    var productId = $(this).attr("for");
    if(!$("#"+productId).is(":checked")){
      addToCart(productId);
    }
  });

});

function addToCart(productId){
	$("."+productId).click();
}
